"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("stremio/components");
var Chip_less_1 = __importDefault(require("./Chip.less"));
var Chip = (0, react_1.memo)(function (_a) {
    var _b;
    var label = _a.label, value = _a.value, active = _a.active, onSelect = _a.onSelect;
    var ref = (0, react_1.useRef)(null);
    var onClick = (0, react_1.useCallback)(function (_a) {
        var currentTarget = _a.currentTarget;
        var value = currentTarget.dataset['value'];
        value && onSelect(value);
    }, [onselect]);
    (0, react_1.useEffect)(function () {
        var _a;
        active && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
            block: 'nearest',
            inline: 'center',
            behavior: 'smooth',
        }));
    }, [active]);
    return (react_1.default.createElement(components_1.Button, { ref: ref, key: value, className: (0, classnames_1.default)(Chip_less_1.default['chip'], (_b = {}, _b[Chip_less_1.default['active']] = active, _b)), tabIndex: 0, "data-value": value, onClick: onClick }, label));
});
exports.default = Chip;
